var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparklineRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 20,
    viewBox: "0 0 46 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1688_2032)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.398 24L51 19V42H0V0L6.2449 5L8.32653 11.5L11.449 7.5L14.5714 11.5L19.7755 5L26.0204 7.5L28.6224 5L31.2245 11.5L34.3469 7.5L37.9898 19H42.6735L45.7959 32.5L48.398 24Z",
    fill: "url(#paint0_linear_1688_2032)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 19L47.5 24L44 26.5L42 19H37.5L34 7.5L31 11.5L28.5 5L26 7.5L20 5L15 11.5L12 7.5L9 11.5L7 5L1 0",
    stroke: "#C91D12",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1688_2032",
    x1: 25.5,
    y1: 3.47694e-8,
    x2: 25.0196,
    y2: 39.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C91D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706477,
    stopColor: "#C91D12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1688_2032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklineRed);
export default __webpack_public_path__ + "static/media/sparkline-red.6cb4779a1d4cfb52276de97ae62796a9.svg";
export { ForwardRef as ReactComponent };